import React from "react";
import { Rating } from "react-simple-star-rating";
import relativeTime from "../../utilities/relativeTime";
import "./Review.scss";
export default function Review(props) {
  return (
    <div className="review">
      <Rating
        ratingValue={props.data.rating}
        readonly={true}
        size={20}
        allowHalfIcon={true}
      />

      <p className="review-text">{props.data.text}</p>

      <p className="review-name">{props.data.name}</p>
      <p className="review-time">{relativeTime(props.data.timestamp)}</p>
    </div>
  );
}
